import React from 'react';
import { useTheme } from '@mui/material/styles';
import { useForm } from 'react-hook-form';
import { ValidatableField } from '../form';
import { useMonitorMap } from '../map/google';
function RadarPanel() {
    const { radarRadius, setRadarRadius } = useMonitorMap();
    const theme = useTheme();
    const { register, formState } = useForm({ mode: 'onChange' });
    const { errors } = formState;
    return (React.createElement(ValidatableField, { label: "Radar Radius", margin: "none", color: "primary", inputProps: {
            style: {
                padding: '0 !important',
                fontSize: '0.8rem',
                color: theme.palette.text.primary,
            },
        }, InputProps: {
            sx: {
                '&::before': {
                    borderWidth: 0,
                },
            },
            endAdornment: 'm',
        }, shortMessage: true, type: "number", value: radarRadius, registerOptions: {
            value: radarRadius,
            required: true,
            min: 100,
            max: 100000,
            onChange: (e) => setRadarRadius?.(parseFloat(e.target.value)),
        }, register, errors }));
}
export default React.memo(RadarPanel);
